// components/ProtectedRoute.js
import React from "react"
import { Navigate } from "react-router-dom"

const ProtectedRoute = ({ allowedRoles=[], children }) => {
  const user = JSON.parse(localStorage.getItem("user"))

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />
  }

  return children
}

export default ProtectedRoute

